module.exports = __webpack_public_path__ + "img/ForFood.1fac32eb.png";